import { useState } from 'react'
import { YourInfo } from '../../components/onboardingCards/user/YourInfo'
import { AccountRoleSelection } from '../../components/onboardingCards/AccountRoleSelection'
import { VendorOnboarding } from '../../components/onboardingCards/vendor/VendorOnboarding'

import AuthCommonCard from '../../components/molecules/AuthCommonCard'
import AuthCommonForm from '../../components/molecules/AuthCommonForm'
import OnBoardingRoles from '../../components/onboardingCards/OnBoardingRoles'
import PlannerOnboarding from '../../components/onboardingCards/kazooPlanner/PlannerOnboarding'

export const OnboardingAccount = () => {
	const [role, setRole] = useState('')

	const [userDetails, setUserDetails] = useState({
		firstName: '',
		lastName: '',
		preferredName: '',
		phone: '',
		profilePic: null,
		budget: 0,
		venue: '',
		activationCode: '',
        hasActivationCode: false,
		businessName: '',
		businessAddress: '',
		type: '',
		lowerPriceRange: 1000,
		upperPriceRange: 5000,
		maxCapacity: 150,
		businessTypes: [],
  		customBusinessType: '',
  		services: [],
	})

	// Dynamically set the title based on selected role
	const getTitleForRole = () => {
		switch (role) {
			case 'user':
				return 'Your Info'
			case 'vendor':
				if(userDetails.type) return null
				return 'Select Vendor Type'
			case 'kazoo-planner':
				return 'Wow! Love is in the Air!'
			default:
				return 'Welcome to OnTimeBride!'
		}
	}
	const renderForm = () => {
		if (role === 'user') {
			return (
				<YourInfo
					userDetails={userDetails}
					setUserDetails={setUserDetails}
                    role={role}
					setRole={setRole}
				/>
			)
		} else if (role === 'vendor') {
			return (
				<VendorOnboarding
					userDetails={userDetails}
					setUserDetails={setUserDetails}
                    role={role}
					setRole={setRole}
				/>
			)
		} else if (role === 'kazoo-planner') {
			return (
				<PlannerOnboarding
					userDetails={userDetails}
					setUserDetails={setUserDetails}
					setRole={setRole}
				/>
			)
		} else {
			return <AccountRoleSelection setRole={setRole} />
		}
	}

	return (
		<>
			{/* <OnBoardingComp />
			<OnBoardingRoles /> */}
			<AuthCommonCard>
				<AuthCommonForm
					title={getTitleForRole()} // Set dynamic title based on role
					style={{ padding: '20px 33px' }}
				>
					<OnBoardingRoles renderForm={renderForm} />
				</AuthCommonForm>
			</AuthCommonCard>
		</>
	)
}
